__turbopack_context__.v({
  "debug": "styles-module-scss-module__74iNIG__debug",
  "debug_media_queries": "styles-module-scss-module__74iNIG__debug_media_queries",
  "is_showing": "styles-module-scss-module__74iNIG__is_showing",
});
